import React from 'react';
import { AppControlContext } from '../../context/AppControlContext';
import './refLibModal.scss';

const Modal = ({ showFooter, showHeader,isLink, ...props }) => {
  const { setModalIsOpen, modalIsOpen, LinkModalIsOpen,setLinkModalIsOpen } = React.useContext(AppControlContext);
  const { children } = props;
  return (
    <div className="modal" id="refLibModal" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              if(isLink){
                setLinkModalIsOpen(!LinkModalIsOpen);
              } else {
                setModalIsOpen(!modalIsOpen);
              }
              
              
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="modal-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
